import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Prismic from 'prismic-javascript';
import { logError } from '@/helpers/log-helper';

function getRef(context, api) {
  var previewRef = context.$cookies.get(Prismic.previewCookie);
  var masterRef = api.refs.find(ref => ref.isMasterRef === true).ref;
  return previewRef || masterRef;
}

function fetchArticlesByTag(_x, _x2, _x3, _x4) {
  return _fetchArticlesByTag.apply(this, arguments);
}

function _fetchArticlesByTag() {
  _fetchArticlesByTag = _asyncToGenerator(function* (context, params, page, pageSize) {
    var locale = context.state.i18n.currentLocale;

    try {
      var query = [Prismic.Predicates.at('document.type', 'article')];

      if (params) {
        query.push(Prismic.Predicates.at('document.tags', params.tags));
      }

      var endPoint = context.state.sharedEnv.payload.prismic;
      var api = yield Prismic.getApi(endPoint);
      var ref = getRef(context, api);
      var response = api.query(query, _objectSpread(_objectSpread(_objectSpread({
        fetch: ['article.image', 'article.date', 'article.description', 'article.main_title', 'article.reading_time', 'article.difficulty']
      }, pageSize && {
        pageSize
      }), page && {
        page
      }), {}, {
        orderings: '[my.article.date desc]',
        lang: locale.iso ? locale.iso.toLowerCase() : '',
        ref
      }));
      return response;
    } catch (e) {
      logError({
        msg: e,
        context
      });
      return null;
    }
  });
  return _fetchArticlesByTag.apply(this, arguments);
}

function fetchContent(_x5, _x6) {
  return _fetchContent.apply(this, arguments);
}

function _fetchContent() {
  _fetchContent = _asyncToGenerator(function* (context, params) {
    var locale = context.state.i18n.currentLocale;

    try {
      var query = [Prismic.Predicates.at('document.type', params.type)];

      if (params.slug) {
        query.push(Prismic.Predicates.at("my.".concat(params.type, ".slug"), params.slug));
      }

      if (params.type === 'generic' && params.alias) {
        query.push(Prismic.Predicates.at("my.".concat(params.type, ".alias"), params.alias));
      }

      var endPoint = context.state.sharedEnv.payload.prismic;
      var api = yield Prismic.getApi(endPoint);
      var ref = getRef(context, api);
      var response = api.query(query, {
        lang: locale.iso ? locale.iso.toLowerCase() : '',
        ref
      });
      return response;
    } catch (e) {
      logError({
        msg: e
      });
      return null;
    }
  });
  return _fetchContent.apply(this, arguments);
}

function fetchDocumentsById(_x7, _x8) {
  return _fetchDocumentsById.apply(this, arguments);
}

function _fetchDocumentsById() {
  _fetchDocumentsById = _asyncToGenerator(function* (context, ids) {
    var locale = context.state.i18n.currentLocale;

    try {
      var endPoint = context.state.sharedEnv.payload.prismic;
      var api = yield Prismic.getApi(endPoint);
      var ref = getRef(context, api);
      var promises = [];
      ids.forEach(e => {
        var query = [Prismic.Predicates.at('document.id', e)];
        var response = api.query(query, {
          lang: locale.iso ? locale.iso.toLowerCase() : '',
          ref
        });
        promises.push(response);
      });
      var response = yield Promise.all(promises);
      return {
        results: response.map(e => e.results[0])
      };
    } catch (e) {
      logError({
        msg: e
      });
      return null;
    }
  });
  return _fetchDocumentsById.apply(this, arguments);
}

export { fetchContent, fetchDocumentsById, fetchArticlesByTag };